import React from 'react';
import { AppBar, Backdrop, Box, CircularProgress, Toolbar, useTheme } from '@mui/material';
import { observer } from 'mobx-react';
import { TopBarProps } from './types';
import { MainBox, TopBarStyle } from './style';
import useData from './hooks';
import LeftItems from './LeftItems';
import RightItems from './RightItems';
import CenterItems from './CenterItems';
import { TopBarName } from './const';
import { useModuleContext } from '00.app/module/moduleContext';
import { useIsMobile } from '80.quickConnect.Core/hooks';

const TopBar = ({ showLeftMenuButton, leftChildren, rightChildren, pageTitle, hideOuMenu }: TopBarProps) => {
  const { isLoggingOut } = useData(pageTitle);
  const theme = useTheme();
  const isMobile = useIsMobile();
  const module = useModuleContext();

  return (
    <>
      <AppBar
        elevation={0}
        data-cy={TopBarName}
        color={isMobile ? 'default' : 'transparent'}
        position="sticky"
        id="topBarComponent"
        sx={TopBarStyle(theme, module)}
      >
        <Toolbar disableGutters>
          <Box sx={MainBox}>
            <LeftItems showLeftMenuButton={showLeftMenuButton}>{leftChildren}</LeftItems>
            <CenterItems pageTitle={pageTitle} showLeftMenu={false} searchView={false} />
            <RightItems hideOuMenu={hideOuMenu}>{rightChildren}</RightItems>
            <Backdrop open={isLoggingOut}>
              <CircularProgress />
            </Backdrop>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default observer(TopBar);
